/* screens/settings/subscriptionOverride.js — локальные правки подписки на экране тарифа.

   После смены тарифа, отмены перехода или переключения автопродления экран кладёт
   свежий ответ сервера поверх загруженной подписки — без перезапроса. Правка
   действует только для ТОГО ЖЕ ключа (вкладка × пространство × параметры адреса):
   панель тарифа в «Заведениях» не перемонтируется при выборе другого заведения, и
   правка без ключа показала бы на заведении Б тариф, срок, запланированный переход
   и канал оплаты заведения А — а в окне согласия дату окончания чужого срока. */

function withOverride(data, override, key) {
  if (!data) return null;
  if (!override || override.key !== key) return data;
  return { ...data, ...override.patch };
}

/* Новая правка поверх прежней — только если прежняя про тот же ключ. */
function nextOverride(prev, key, patch) {
  const base = prev && prev.key === key ? prev.patch : {};
  return { key, patch: { ...base, ...patch } };
}

export { withOverride, nextOverride };
